import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import EmptyApiKeyState from 'images/no_access.svg';
import { NoData } from '@ui/NoData';
import { PlusOutlined } from '@ant-design/icons';
import React from 'react';

import { Button, Flex, Space, Typography } from 'antd';

const { Title } = Typography;

export const DataDictionaryApiKeysEmptyState: React.FC<{ onCreate?: () => void }> = ({ onCreate }) =>
	<Flex
		align='center'
		justify='center'
		vertical>
		<Space
			align='center'
			direction='vertical'
			size='large'>
			<NoData
				description=''
				image={ EmptyApiKeyState }
				styles={ {
					image: {
						height: 200
					}
				} } />
			<Title level={ 3 }>{ COPY_SPECIFIC.NO_API_KEYS_YET }</Title>
			<Typography>
				{ COPY_SPECIFIC.CREATE_API_KEY_DESCRIPTION }
			</Typography>
			<Button
				icon={ <PlusOutlined /> }
				onClick={ onCreate }
				size='large'
				style={ { marginTop: 16 } }
				type='primary'>
				{ COPY_SPECIFIC.CREATE_API_KEY }
			</Button>
		</Space>
	</Flex>;
